/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ScheduleItemDto } from '../models/PagedResultDto_ScheduleItemDto';
import type { Wealthlane_SchedulerService_Dtos_ResponseDto } from '../models/Wealthlane_SchedulerService_Dtos_ResponseDto';
import type { Wealthlane_SchedulerService_Dtos_Schedule_CreateScheduleDto } from '../models/Wealthlane_SchedulerService_Dtos_Schedule_CreateScheduleDto';
import type { Wealthlane_SchedulerService_Dtos_Schedule_Wealthlane_SchedulerService_Dtos_ScheduleItemDetailDto } from '../models/Wealthlane_SchedulerService_Dtos_Schedule_Wealthlane_SchedulerService_Dtos_ScheduleItemDetailDto';
import type { Wealthlane_SchedulerService_Dtos_Schedule_Wealthlane_SchedulerService_Dtos_TaskRunerResponseDto } from '../models/Wealthlane_SchedulerService_Dtos_Schedule_Wealthlane_SchedulerService_Dtos_TaskRunerResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ScheduleService {

    /**
     * @param requestBody 
     * @returns Wealthlane_SchedulerService_Dtos_ResponseDto OK
     * @throws ApiError
     */
    public static postApiSchedulerApiAppSchedule(
requestBody?: Wealthlane_SchedulerService_Dtos_Schedule_CreateScheduleDto,
): CancelablePromise<Wealthlane_SchedulerService_Dtos_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/scheduler/api/app/schedule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fromCreatedDate 
     * @param toCreatedDate 
     * @param scheduleItemStatusIds 
     * @param taskTypeIds 
     * @param recurrenceTypeIds 
     * @param timeZone 
     * @param searchKeyword 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ScheduleItemDto OK
     * @throws ApiError
     */
    public static getApiSchedulerApiAppSchedule(
fromCreatedDate?: string,
toCreatedDate?: string,
scheduleItemStatusIds?: Array<string>,
taskTypeIds?: Array<string>,
recurrenceTypeIds?: Array<string>,
timeZone?: string,
searchKeyword?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ScheduleItemDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/scheduler/api/app/schedule',
            query: {
                'FromCreatedDate': fromCreatedDate,
                'ToCreatedDate': toCreatedDate,
                'ScheduleItemStatusIds': scheduleItemStatusIds,
                'TaskTypeIds': taskTypeIds,
                'RecurrenceTypeIds': recurrenceTypeIds,
                'TimeZone': timeZone,
                'SearchKeyword': searchKeyword,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param taskRunnerUserId 
     * @param requestBody 
     * @returns Wealthlane_SchedulerService_Dtos_ResponseDto OK
     * @throws ApiError
     */
    public static putApiSchedulerApiAppSchedule(
id: string,
taskRunnerUserId?: string,
requestBody?: Wealthlane_SchedulerService_Dtos_Schedule_CreateScheduleDto,
): CancelablePromise<Wealthlane_SchedulerService_Dtos_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/scheduler/api/app/schedule/{id}',
            path: {
                'id': id,
            },
            query: {
                'taskRunnerUserId': taskRunnerUserId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_SchedulerService_Dtos_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiSchedulerApiAppSchedule(
id: string,
): CancelablePromise<Wealthlane_SchedulerService_Dtos_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/scheduler/api/app/schedule/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_SchedulerService_Dtos_Schedule_Wealthlane_SchedulerService_Dtos_ScheduleItemDetailDto OK
     * @throws ApiError
     */
    public static getApiSchedulerApiAppSchedule1(
id: string,
): CancelablePromise<Wealthlane_SchedulerService_Dtos_Schedule_Wealthlane_SchedulerService_Dtos_ScheduleItemDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/scheduler/api/app/schedule/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_SchedulerService_Dtos_Schedule_Wealthlane_SchedulerService_Dtos_TaskRunerResponseDto OK
     * @throws ApiError
     */
    public static getApiSchedulerApiAppScheduleTaskRunner(): CancelablePromise<Array<Wealthlane_SchedulerService_Dtos_Schedule_Wealthlane_SchedulerService_Dtos_TaskRunerResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/scheduler/api/app/schedule/task-runner',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
